import { SpotifyLevel } from 'wb-spotify/app/routes/superGrid/utils';
import {
	CampaignStatus, AdStatus, GroupStatus, AdAccountStatus,
} from 'wb-spotify/graphql/generated';
import { startCase } from 'lodash';
import { StatusFilter, EntityFilter, translate } from '@aleph/shared-components';

export const LEVEL_NAME_FILTER = {
	[SpotifyLevel.AD_ACCOUNT]: 'adAccountName',
	[SpotifyLevel.CAMPAIGN]:   'campaignName',
	[SpotifyLevel.GROUP]:      'groupName',
	[SpotifyLevel.AD]:         'adName',
};

export const LEVEL_ID_FILTER = {
	[SpotifyLevel.AD_ACCOUNT]: 'clientId',
	[SpotifyLevel.CAMPAIGN]:   'campaignId',
	[SpotifyLevel.GROUP]:      'groupId',
	[SpotifyLevel.AD]:         'adId',
};

export const getFilterConfig = (
	setFilters,
	getCurrentFilters,
	getEntityOptions,
) => ([
	{
		label:          'Ad account status',
		value:          'adAccountStatus',
		component:      StatusFilter,
		componentProps: ({
			filterLevel:   SpotifyLevel.AD_ACCOUNT,
			filterName:    'adAccountStatus',
			filterOptions: Object.values(AdAccountStatus).map(status => ({
				value: status,
				label: translate(`sp: filter ad account status ${status}`, { defaultValue: startCase(status.toLowerCase()) }),
			})),
			setFilters,
			getCurrentFilters,
		}),
	},
	{
		label:          'Campaign status',
		value:          'campaignStatus',
		component:      StatusFilter,
		componentProps: ({
			filterLevel:   SpotifyLevel.CAMPAIGN,
			filterName:    'campaignStatus',
			filterOptions: Object.values(CampaignStatus).map(status => ({
				value: status,
				label: translate(`sp: filter campaign status ${status}`, { defaultValue: startCase(status.toLowerCase()) }),
			})),
			setFilters,
			getCurrentFilters,
		}),
	},
	{
		label:          'Group status',
		value:          'groupStatus',
		component:      StatusFilter,
		componentProps: ({
			filterLevel:   SpotifyLevel.GROUP,
			filterName:    'groupStatus',
			setFilters,
			getCurrentFilters,
			filterOptions: Object.values(GroupStatus).map(status => ({
				value: status,
				label: translate(`sp: filter group status ${status}`, { defaultValue: startCase(status.toLowerCase()) }),
			})),
		}),
	},
	{
		label:          'Ad status',
		value:          'adStatus',
		component:      StatusFilter,
		componentProps: ({
			filterLevel:   SpotifyLevel.AD_ACCOUNT,
			filterName:    'adStatus',
			setFilters,
			getCurrentFilters,
			filterOptions: Object.values(AdStatus).map(status => ({
				value: status,
				label: translate(`sp: filter ad status ${status}`, { defaultValue: startCase(status.toLowerCase()) }),
			})),
		}),
	},
	{
		label:          'Ad accounts',
		value:          'clientId',
		component:      EntityFilter,
		componentProps: ({
			filterLevel: SpotifyLevel.AD_ACCOUNT,
			filterName:  'clientId',
			setFilters,
			getEntityOptions,
		}),
	},
	{
		label:          'Campaigns',
		value:          'campaignId',
		component:      EntityFilter,
		componentProps: ({
			filterLevel: SpotifyLevel.CAMPAIGN,
			filterName:  'campaignId',
			setFilters,
			getEntityOptions,
		}),
	},
	{
		label:          'Groups',
		value:          'groupId',
		component:      EntityFilter,
		componentProps: ({
			filterLevel: SpotifyLevel.GROUP,
			filterName:  'groupId',
			setFilters,
			getEntityOptions,
		}),
	},
	{
		label:          'Ads',
		value:          'adId',
		component:      EntityFilter,
		componentProps: ({
			filterLevel: SpotifyLevel.AD,
			filterName:  'adId',
			setFilters,
			getEntityOptions,
		}),
	},
]);

export function syncFilterOrder(currentKeys: string[], existingOrder: string[]): string[] {
	const currentKeysSet = new Set(currentKeys);
	const existingOrderSet = new Set(existingOrder);
	const preservedOrder = existingOrder.filter(key => currentKeysSet.has(key));
	const newKeys = currentKeys.filter(key => !existingOrderSet.has(key));

	return [...preservedOrder, ...newKeys];
}
